import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import SpecialtyCard from '../components/SpecialtyCard';
import './Specialties.css';

export default function Specialties() {
  const [specialties, setSpecialties] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/specialties`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setSpecialties)
      .catch(() => setSpecialties([]));
  }, []);

  if (specialties === null) {
    return (
      <main className="specialties-main">
        <div className="specialties-loading">Loading...</div>
      </main>
    );
  }

  return (
    <main className="specialties-main">
      <header className="specialties-header">
        <h1>Specialties</h1>
        <p className="specialties-lead">
          Areas of focus that shape the work — from techniques and modalities to specific concerns I love helping people with.
        </p>
      </header>
      {specialties.length === 0 ? (
        <p className="specialties-empty">
          Specialties are being prepared — please <a href="/contact">get in touch</a> for details.
        </p>
      ) : (
        <div className="specialty-grid">
          {specialties.map((s) => (
            <SpecialtyCard key={s.id} specialty={s} />
          ))}
        </div>
      )}
    </main>
  );
}
